import {gsap} from 'gsap'

export const animateAssetZoom = (animationElements: Element[], content: Element, immediate: boolean = false) => {
  if (animationElements.length > 0 && content) {
    const motionQuery = window.matchMedia('(prefers-reduced-motion: reduce)')
    if (!motionQuery.matches) {
      const assetAnimations = animationElements.flatMap((element, index) => {
        const item = element.querySelector('[data-animate="item"]')
        if (!item) return []

        gsap.set(item, {scale: 1.1})
        return [{item, delay: index * 0.2}]
      })

      if (assetAnimations.length === 0) {
        return () => {}
      }

      const createTimeline = () => {
        const tl = gsap.timeline({delay: 0.1})

        for (const {item, delay} of assetAnimations) {
          tl.to(item, {scale: 1, duration: 1.6, ease: `expo.out`}, delay)
        }

        return tl
      }

      let timeline: gsap.core.Timeline | undefined
      let observer: IntersectionObserver | undefined

      if (immediate) {
        timeline = createTimeline()
      } else {
        observer = new IntersectionObserver(
          entries => {
            for (const entry of entries) {
              if (entry.isIntersecting) {
                timeline = createTimeline()
                observer?.unobserve(entry.target)
              }
            }
          },
          {threshold: 0.5},
        )
        observer.observe(content)
      }

      // Cancel and reset if reduced motion gets enabled after mount
      const handleMotionChange = () => {
        if (!motionQuery.matches) return

        timeline?.kill()
        observer?.disconnect()
        gsap.set(
          assetAnimations.map(({item}) => item),
          {scale: 1},
        )
      }
      motionQuery.addEventListener('change', handleMotionChange)

      return () => {
        timeline?.kill()
        observer?.disconnect()
        motionQuery.removeEventListener('change', handleMotionChange)
      }
    }
  }

  return () => {}
}
